import React, { useRef } from "react";
import { useElementBox } from "../hooks/useElementBox";
import { couponMeshGradient } from "../utils/couponMeshGradient";
import { TICKET_VARIANT_CLASSIC, ticketPath } from "../utils/ticketPath";

const MIN_W = 24;
const MIN_H = 24;

/**
 * List row with the same side notches as floating coupons.
 */
const CouponListRow = ({ coupon, onClick }) => {
  const btnRef = useRef(null);
  const dim = useElementBox(btnRef, true);
  const { w, h } = dim;
  const path =
    w >= MIN_W && h >= MIN_H ? ticketPath(w, h, TICKET_VARIANT_CLASSIC) : "";

  return (
    <li>
      <button
        ref={btnRef}
        type="button"
        className="coupon-list-row"
        onClick={onClick}
      >
        {path ? (
          <>
            <span
              className="coupon-list-row-face"
              aria-hidden
              style={{
                clipPath: `path("${path}")`,
                background: `linear-gradient(rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.42)), ${couponMeshGradient(coupon.name)}`,
              }}
            />
          </>
        ) : null}
        <span className="coupon-list-emoji" aria-hidden>
          {coupon.emoji}
        </span>
        <span className="coupon-list-row-text">
          <span className="coupon-list-name">{coupon.name}</span>
          <span className="coupon-list-desc">{coupon.description}</span>
        </span>
      </button>
    </li>
  );
};

export default CouponListRow;
